import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Tabs from "@material-ui/core/Tabs";

import CustomTab from "../Common/CustomTab";

import { setBreadcrumb } from "../../actions/common";

import colors from "../../assets/style/colors";

const styles = {
  mainContent: {
    maxWidth: "1920px",
    maxHeight: "calc(100vh - 290px)",
    overflow: "auto",
  },
  container: {
    height: "50px",
    width: "100%",
    backgroundColor: colors.white,
    paddingLeft: "24px",
    boxShadow: `0px 0px 4px 0px ${colors.black23}`,
  },
  tabs: {
    height: "50px",
    float: "left",
    minHeight: "50px",
  },
};

const UsersAndRoles = (props) => {
  const { classes, dispatch, url, topElement } = props;

  const section = url ? (url.includes("roles") ? "roles" : "users") : "users";

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        { name: I18n.get("topbar_admin") },
        { name: I18n.get("topbar_usersAndRoles") },
      ])
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container className={classes.container}>
          <Tabs
            value={section}
            onChange={(e, value) => props.history.push(`/admin/${value}`)}
            indicatorColor="primary"
            centered
            className={classes.tabs}
          >
            <CustomTab
              height="50px"
              label={I18n.get("users_users")}
              value={"users"}
            />
            <CustomTab
              height="50px"
              label={I18n.get("users_roles")}
              value={"roles"}
              disabled
            />
          </Tabs>
        </Grid>
      </Grid>
      <Grid item xs>
        <Grid
          container
          direction="column"
          wrap="nowrap"
          className="mainContent"
          style={{
            margin: "24px",
            padding: "24px",
            height: "calc(100vh - 198px)",
            minHeight: "unset",
            overflow: "auto",
            width: "auto",
          }}
        >
          {topElement && (
            <Grid item style={{ marginBottom: "24px" }}>
              {topElement}
            </Grid>
          )}
          <Grid item xs>
            <Box className={`${classes.mainContent}`}>{props.children}</Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default connect()(withStyles(styles)(UsersAndRoles));
